export default __webpack_public_path__ + "static/media/steam.5afaa4cc.svg";